module.exports = __webpack_public_path__ + "html/week8_2728306d4c0b45401e4c8d98c61931d8.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/education/week8.html
// module id = eWSb
// module chunks = 118